export const addFieldErrors = errors => ({
  type: "FIELD_ERRORS_ADD",
  errors
});

export const clearFieldErrors = () => ({
  type: "FIELD_ERRORS_CLEAR"
});
